import { render } from "./boardAdmin.vue?vue&type=template&id=8e5d887c&scoped=true"
import script from "./boardAdmin.vue?vue&type=script&lang=js"
export * from "./boardAdmin.vue?vue&type=script&lang=js"

import "./boardAdmin.vue?vue&type=style&index=0&id=8e5d887c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5d887c"]])

export default __exports__